<template>
  <div class="privacy-policy">
    <h1 class="privacy-policy__title page-title">
      Deletion account policy
    </h1>

    <div class="card" v-html="dataDeletionInfo.content"></div>
  </div>
</template>

<script>
import { getPrivacyPolicy } from '@/api/privacy.js';

export default {
  name: 'PersonalDataDeletion',
  data() {
    return {
      dataDeletionInfo: '',
    };
  },
  mounted() {
    this.fetchDataDeletionInfo();
  },
  methods: {
    async fetchDataDeletionInfo() {
      const { data, success } = await getPrivacyPolicy({ type: 2 });
      if (success) {
        this.dataDeletionInfo = data;
      }
    },
  },
};
</script>
